import { render, staticRenderFns } from "./EditJurnal.vue?vue&type=template&id=710c2166&scoped=true&"
import script from "./EditJurnal.vue?vue&type=script&lang=js&"
export * from "./EditJurnal.vue?vue&type=script&lang=js&"
import style0 from "./EditJurnal.vue?vue&type=style&index=0&id=710c2166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c2166",
  null
  
)

export default component.exports